export default "__VITE_ASSET__BQmuva$Y__"